document.addEventListener('DOMContentLoaded', () => {
  const burger  = document.querySelector('.burger');
  const navWrap = document.querySelector('.header_nav_wrap');
  const body    = document.body;

  function openMenu() {
    navWrap.classList.add('is-open');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    navWrap.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden'; // 背景スクロール止める
  }

  function closeMenu() {
    navWrap.classList.remove('is-open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    navWrap.setAttribute('aria-hidden', 'true');
    body.style.overflow = ''; // 元に戻す
  }

  if (burger) {
    burger.addEventListener('click', () => {
      if (navWrap.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  // ESCキーで閉じる（SPメニュー開いてたら閉じる）
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && navWrap.classList.contains('is-open')) {
      closeMenu();
    }
  });
});

// 追従ボタン表示切り替え
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.side_follow');
  const footer = document.querySelector('.footer');
  if (!btn || !footer) return;

  const gap = 0;

  let ticking = false;

  const update = () => {
    ticking = false;

    const btnRect = btn.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();

    const overlap = (btnRect.bottom + gap) > footerRect.top;

    btn.classList.toggle('is-hidden', overlap);
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
});
